const isServerSide = () => !(typeof window !== 'undefined' && window.document && window.document.createElement)

module.exports = isServerSide
